// @ts-ignore
import EventSessionCollection from '../../core/gd-model/event/session-collection';
// @ts-ignore
import SessionEventFactory from "./session-event-factory";
import CustomViewsSessionCollection from "../model2/custom-view/sesson-collection";
// @ts-ignore
import {Deferred} from 'simply-deferred';
import ProjectCollectionCollectionSession from "../model2/project-collection/project-collection-collection-session";
import ApiRequestForm from "../gd/api/request-form";
import RequestFormsCollection from "../../app/tools/request-forms2/model/collection";
import TaskTypesCollection from "../model2/task-type/task-types-collection"
import Companies from "../model2/company/collection";
import CurrentUser from "../model2/user/current-user";
import StarredItemsCollection from "../model2/starred/collection"
// Session collections
import ProjectSessionCollection from "../model2/project/collection"
import ProjectTemplateCollection from "../model2/project-template/collection"

import RecentTasks from '../gd-model/recent/recent-tasks'
import ApiAttendance from "../gd/api/attendance";
import CustomEntitiesCollection from "../model2/custom-entity/collection"
import OfficesCollection from "../model2/office/collection";
import SessionProjectUsers from "../gd-model/project-user/project-users";
import AssignedTasksCollection from "../gd-model/assigned-tasks/assigned-tasks-collection";
import ChatsCollection from "../model2/chat/chat/collection";
import ExpenseCategoriesCollection from "../model2/expenses/expense-category/collection";
import ApiSession from "../gd/api/session";
import PinsCollection from "../model2/pin/pins";
import Departments from "../model2/department/departments";
import CompanyUsersCollection from "../model2/company-user-new/collection";
import SessionCompanyUsers from "../model2/company-user-new/collection-session";
import Users from "../model2/user/collection";

// const UsersCollection = require('../gd-model/user/gd-users');
const GDCustomFields = require('../gd-model/custom-field/gd-custom-fields');

const GDProjectUsers = require('../gd-model/project-user/project-users');
const GDModules = require('../gd-model/modules/modules');
const GDWorkScheduleAccess = require('../gd-model/work-schedule-access/work-schedule-access-collection');
const DashboardTilesCollection = require('../gd-model/dashboard/tile-collection');
const DashboardRecentActivityCollection  = require('../gd-model/dashboard/recent-activity-collection');
const StatusesCollection = require('../gd-model/status/status-collection');
const ProjectTypeCollection = require('../gd-model/project-type/project-type-collection');
const GroupTypeCollection = require('../gd-model/group-type/group-type-collection');
const SessionCounters = require('./counters');


const RecentProjectsNewTask = require('../gd-model/recent/recent-projects-new-task');
const SessionLoader = require('../../core/gd/data/session-loader');


// OLD
// const GDDepartments = require('../gd-model/department/gd-departments');
// const GDDepartment = require('../gd-model/department/gd-department');

const debugError        = true
const debugMissing      = false
const debugMonitor      = true

export default class GDSession {


    // USER
    public me                   : CurrentUser
    public recent               : any

    // USER WORK
    public myWork : any //new MyWorkCollection();
    public meetings : any
    public reminders : any
    public myWorkSortPositions : any

    // USER ITEMS

    // PROJECT


    // COMPANY
    public companies           : Companies
    public companyUsers        : SessionCompanyUsers
    public deletedCompanyUsers : CompanyUsersCollection // used to keep deleted users ?

    // COMPANY SETTINGS

    public offices             : OfficesCollection
    public quickNotes          : any


    // accountSettings : new GDAccountSettings();

    public statuses             : any

    public dashboard            : any
    public dashboardActivity    : any

    public users                : Users
    public events               : any

    // public invitations : any


    public projects            : ProjectSessionCollection
    public templatesList       : any
    public projectUsers        : SessionProjectUsers


    public projectCollections   : ProjectCollectionCollectionSession // any


    public pins                 : PinsCollection
    public starredItems         : StarredItemsCollection = new StarredItemsCollection([])

    public departments          : Departments
    // public department           : any // a zachem eto ? a ono in use ?




    // koroche tut null potomu chto netu loaded / ne loaded
    public assignedTasks        : AssignedTasksCollection | null = null // why null ? strange


    public counters             :  any

    public taskTypes            : TaskTypesCollection
    public projectTypes         : any
    public groupTypes           : any
    public customFields         : any



    public customViews          : CustomViewsSessionCollection



    public modules              : any
    public workScheduleAccess   : any



    // LAZY

    public chats                : ChatsCollection = new ChatsCollection([])
    public chatsLoaded          : boolean = false

    _noteTypes                  : any
    _crmContacts                : any
    _crmAccounts                : any
    _todoListTemplates          : any

    private _expenseCategories? : ExpenseCategoriesCollection   = undefined

    public requestFormsLoaded   : boolean   = false
    private _requestForms?      : RequestFormsCollection

    // requestForms            : RequestFormsCollection
    // attendanceStatus        : any


    private _attendanceStatus?      : any // ???


    // SESSION CLASS
    private historyMaxEvents    : number = 200
    private historyEvents       : any = {}

    public customEntities       : CustomEntitiesCollection

    constructor() {

        this._attendanceStatus = undefined

        this.offices            = new OfficesCollection([])
        this.quickNotes         = null;    // imenno null (null = not in session)

        this.me                 = new CurrentUser({id:'temp'});

        this.statuses           = new StatusesCollection();

        this.dashboard = new DashboardTilesCollection();
        this.dashboardActivity = new DashboardRecentActivityCollection();

        this.users              = new Users();    // need change...

        // this.invitations    = new GDInvitation();

        // this.companies      = new MyCompaniesCollection(); - old
        this.companies              = new Companies([])

        this.companyUsers           = new CompanyUsersCollection([]);
        this.deletedCompanyUsers    = new CompanyUsersCollection([]);    // temp patch need companyUser.isDeleted refactoring

        this.projects           = new ProjectSessionCollection([])
        this.templatesList      = new ProjectTemplateCollection([])
        this.projectUsers       = new GDProjectUsers();

        this.projectCollections = new ProjectCollectionCollectionSession([])  // portfolios...

        // this.favorites = new GDFavorites(); - chto to mega staroe
        this.pins               = new PinsCollection([]);

        // this.departments        = new GDDepartments();
        this.departments        = new Departments()
        // this.department         = new GDDepartment();

        // these are filled by updateSessionCollections call
        this.myWork = null; //new MyWorkCollection();
        this.assignedTasks = null; // new AssignedTasksCollection();
        this.meetings = null;
        this.reminders = null;
        this.myWorkSortPositions = null;

        // Old we dont' have updates in session anymoe!
        // // this.updates = new UpdatesCollection();
        // this.updates = false; // by default it's false...

        // this are session counters i.e. number on notifications and my work ???
        this.counters =  new SessionCounters();

        this.taskTypes = new TaskTypesCollection()
        this.projectTypes = new ProjectTypeCollection();
        this.groupTypes = new GroupTypeCollection();
        this.customFields = new GDCustomFields();

        this.customViews = new CustomViewsSessionCollection();

        this.modules = new GDModules();
        this.workScheduleAccess = new GDWorkScheduleAccess();


        // LAZY loading collections

        this._noteTypes         = false;
        this._todoListTemplates = false;
        this._crmContacts       = false;
        this._crmAccounts       = false;

        this.recent = {
            tasks               : new RecentTasks(),
            projectsNewTask     : new RecentProjectsNewTask(),
        };

        this.events = new EventSessionCollection();

        //session system
        this.historyMaxEvents = 200;
        this.historyEvents = {};


        // session loaded markers
        this.requestFormsLoaded    = false
        this._requestForms         = undefined

        this.customEntities = new CustomEntitiesCollection([]) // should be initiated on initial session reset

        /** TEST PURPOSES ONLY [START] **/
        // const externalEntitiesDummyData = require('../model2/custom-entity/dummy-data')
        // this.customEntities = CustomEntitiesCollection.initFromJson(externalEntitiesDummyData)
        /** TEST PURPOSES ONLY [END] **/
    }

    init() {
        this.recent.tasks.init();

        // this.recent.projects.init();
        //this.recent.projectsNewTask.init(); // NO NEED TO RUN IT AS IT is initialized on creation!
        // this.recent.users.init(); - old to remove
        //this.recent.organizations.init(); // NO NEED TO RUN IT AS IT is initialized on creation!
    }

    getCollectionUpdateRequired(requestCollectionsNames:string[]) {
        return {
            myWork:                 !this.myWork                && requestCollectionsNames.includes('myWork'),
            meetings:               !this.meetings              && requestCollectionsNames.includes('meetings'),
            assignedTasks:          !this.assignedTasks         && requestCollectionsNames.includes('assignedTasks'),
            reminders:              !this.reminders             && requestCollectionsNames.includes('reminders'),
            myWorkSortPositions:    !this.myWorkSortPositions   && requestCollectionsNames.includes('myWorkSortPositions'),
        }
    }

    updateSessionCollections(requestCollectionsNames:string[]) {
        const params = this.getCollectionUpdateRequired(requestCollectionsNames);

        let res;
        if (_.values(params).includes(true)) { // if at least one is required
            res = gd.api.Session.resetMissing(params);
        } else {
            res = new Deferred();
            res.resolve();
        }

        return res;
    }

    // lazy loading

    async attendanceStatus() {
        // return type : AttendanceStatus
        if (this._attendanceStatus === undefined) {
            this._attendanceStatus = await ApiAttendance.getCurrentStatus(moment().format("YYYY-MM-DD")).promise()
        }

        return this._attendanceStatus
    }

    // it's im use...
    set setAttendanceStatus(status:any) {
        this._attendanceStatus = status
    }

    get requestForms():Promise<RequestFormsCollection> | RequestFormsCollection {
        if (!this.requestFormsLoaded) {
            return new Promise(async (resolve, reject) => {
                try {
                    const requestFormData       = await ApiRequestForm.selectRequestForms()
                    this._requestForms          = await RequestFormsCollection.initFromJson(requestFormData)
                    this.requestFormsLoaded    = true

                    resolve(this._requestForms)
                } catch (e) {
                    console.error("Session: requestForms error", e)
                    reject()
                }
            })
        } else {
            return this._requestForms!
        }
    }

    get crmContacts() {

        // Lazy loading supported because we need to have it here to use it in
        // app-loader

        if (this._crmContacts) {
            return this._crmContacts;
        } else {

            // we dont' have note types so need to process a request
            return gd.api.Session.resetMissing({
                'crm': true
            });
        }
    }

    get expenseCategories(): any {

        // Lazy loading supported because we need to have it here to use it in
        // app-loader

        if (this._expenseCategories) return this._expenseCategories;

        // we dont' have note types so need to process a request
        return gd.api.Session.getMissingData({
            'expenseCategoryReset': true
        });
    }

    get crmAccounts() {

        // Lazy loading supported because we need to have it here to use it in
        // app-loader

        if (this._crmAccounts) return this._crmAccounts;

        // we dont' have note types so need to process a request
        return gd.api.Session.resetMissing({
            'crm': true
        });
    }

    get noteTypes() {

        if (this._noteTypes) {
            // so we have note types in session and just return them
            return this._noteTypes;
        } else {
            // we dont' have note types so need to process a request
            return gd.api.Session.resetNoteTypes();
        }
    }

    get todoListTemplates() {
        if (this._todoListTemplates) {
            // so we have data in session and just return them
            return this._todoListTemplates;
        } else {
            // we dont' have note types so need to process a request
            return gd.api.Session.resetTodoListTemplates();
        }
    }

    // set noteTypes(noteTypes) {
    //     this._noteTypes = noteTypes;
    // }

    findMissing(obj:any,callerName:string|null=null) {

        debugMissing && console.groupCollapsed("@Session find missing data", callerName);

        let result : any = {};
        _.forEach(obj,function(val,key){
            let missing = [];

            switch (key) {

                case 'users':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.users.get(id)) return id;
                    });
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'taskTypes':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.taskTypes.get(id)) return id;
                    })
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'customFields':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.customFields.get(id)) return id;
                    });
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'statuses':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.statuses.get(id)) return id;
                    })
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'projects':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.projects.get(id)) return id;
                    })
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'projectsWithParents':
                    let projectsIds = [].concat(val)
                    // @ts-ignore
                    _.map(val, id=>{projectsIds = projectsIds.concat(gd.session.projects.getAllParentsIds(id))});
                    projectsIds = _(projectsIds).uniq().compact().value()

                    missing = _.filter(projectsIds, id=>{
                        if (!gd.session.projects.get(id)) return id;
                    });

                    if (missing.length>0) result[key] = missing;
                    break;

                case 'projectsSettings':
                    missing = val.filter((id:ID)=>{
                        const project = gd.session.projects.get(id);
                        if (!project || _.isNil(project.settings)) return id;
                    });
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'noteTypes':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.noteTypes.get(id)) return id;
                    })
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'expenseCategories':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.expenseCategories.get(id)) return id;
                        else {
                            // ??
                            // console.log(gd.session.expenseCategories.get(id))
                        }
                    });
                    if (missing.length>0) result[key] = missing;
                    break;

                case 'companyUsers':
                    missing = val.filter((id:ID)=>{
                        if (!gd.session.companyUsers.findByCompanyAndUser(gd.companyId, id)) return id
                    })
                    if (missing.length>0) result[key] = missing;
                    break

                case 'crmReset':
                    if (!!val) result[key] = true;
                    break;

                case 'customEntities':
                    missing = val.filter((id: ID)=>{
                        if (!gd.session.customEntities.get(id)) return id
                    })
                    if (missing.length > 0) result[key] = missing
                    break

                default:
                    console.error("Session: findMissing unknown key", key);
            }

            debugMissing && console.log('missing ',key,'=',missing);

            // old - now in every case (!) to support crm
            // if (missing.length>0) result[key] = missing;

        });

        debugMissing && console.groupEnd();

        if (_.size(result)>0) return result;
        else return false;

    }

    // used only in reconnect socket ?
    resetAll() {
        debugMonitor && console.log("session reset all");

        if (gd.companyId) {
            console.log("session reset all");
            ApiSession.fullReset(gd.companyId);
        } else {
            console.error("NO COMPANY ID")
        }
    }

    historyAdd(event:any) {
        this.historyEvents[event.uid] = event;
    }

    // This is general events processor we receive from Ajax Request or Presence
    processEvents(events:any[], receivedFrom= 'unknown'){
        let processSessionEventDone : any = true;

        /*//check if you need load more data before process events
         events.map(rawEvent=>{
         if(rawEvent.object === "project" && rawEvent.method === "reset") {
         console.log("Session processEvents", rawEvent.data);
         }
         });*/


        if (debugMonitor)  {

            if (events.length>1) {
                console.groupCollapsed("@Session new events from",receivedFrom, ": ",events.length);
                _.forEach(events, function(rawEvent, key) {
                    console.log(rawEvent);
                });
                console.groupEnd();
            } else if (!_.isEmpty(events)) {
                console.groupCollapsed("@Session new event from", receivedFrom, ": ",events[0].object, "→", events[0].method);
                _.forEach(events, function(rawEvent, key) {
                    console.log(rawEvent);
                });
                console.groupEnd();
            }

        }

        _.forEach(events, rawEvent=>{
            //Check if we already parse this event
            if (this.historyEvents[rawEvent.uid]) {
                debugMonitor &&  console.warn("SKIP EVENT (already received)",rawEvent);
            } else {
                this.historyAdd(rawEvent);
                // const event = this.eventFactory(rawEvent);
                const event = SessionEventFactory(rawEvent);

                // skip - usually from diff company
                if (event === false) return;

                if (event && event.validate()) {
                    try {
                        event.process();
                    } catch (e) {
                        console.error("#DD92383 Serious session processing error !")
                        console.log(e)
                    }

                    //ToDo: add history of events by uid so we dont' run same event twice (!)
                } else {
                    debugError && console.error("session event not valid",event.uid);
                }
            }
        });




        // POST PROCESS
        //check if you need load more data before process events
        // For example we receive project with localTemplateId, but localTemplateId is not in session (i.e. deleted) ... or something like that...

        let postEventProcessMissingData : any = {};

        events.map((rawEvent)=>{


            if (rawEvent.object === "project" && rawEvent.method === "reset") {
                // console.log("Session processEvents", rawEvent.data);
                const allTemplateIds : ID[] = [];

                if (rawEvent.data) {
                    rawEvent.data.map((project:any)=>{
                        if (project.isTemplate) return;
                        if (project.localTemplateId) allTemplateIds.push(project.localTemplateId);
                    });
                }

                if (allTemplateIds.length > 0) {
                    if (!postEventProcessMissingData.projects) postEventProcessMissingData.projects = [];
                    postEventProcessMissingData.projects = postEventProcessMissingData.projects.concat(_.uniq(allTemplateIds));
                }
            }

            if (rawEvent.object === "project" && rawEvent.method === "new") {
                if (rawEvent.data && rawEvent.data.localTemplateId) {
                    if (!postEventProcessMissingData.projects) postEventProcessMissingData.projects = [];
                    postEventProcessMissingData.projects.push(rawEvent.data.localTemplateId);
                }
            }

        });

        const keys = _.keys(postEventProcessMissingData);
        if (keys.length > 0) {
            processSessionEventDone = new SessionLoader();
            processSessionEventDone.process(this.findMissing(postEventProcessMissingData,'gd-session/session.js'));

            /*processSessionEventDone.done(()=>{
             console.log("Session processEvents processSessionEventDone");
             })*/
        }

        return processSessionEventDone;
    }



    // LAZY

    get expenseCategoriesLoaded():boolean {
        return !!this._expenseCategories
    }



}


